import { Auth } from 'aws-amplify';

export const getUserEmail = () => {
  return Auth.currentAuthenticatedUser().then((user) => {
    return user.attributes['email'];
  });
};
